"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANIMATION_LAYER_DEPTH = void 0;
exports.ANIMATION_LAYER_DEPTH = 2;
